module.exports = {
  "id": "08af4352-9fc9-4bcc-b8ed-2650ee1e04b9",
  "gtmIds": [
    " GTM-N6S5FD22 ",
    "GTM-5SBWWXJ2"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "Indiana Beach",
  "language": "en-US",
  "defaultDateFormat": {
    "id": 2,
    "format": "MM/DD/YYYY",
    "name": "Numeric Month First (04/23/2026)"
  },
  "defaultNumberFormat": {
    "id": 1,
    "name": "English (Comma thousands, Dot decimals)",
    "format": "#,###.##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.lakewinnie.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}